import { useContext } from "react";
import { useTranslation } from "react-i18next";
import KyoceraLogo from "../../assets/images/kyocera-logo.png";
import DevPortalLogo from "../../assets/images/dev_portal_logo.png";
import UnavailableLogo from "../../assets/images/red_unavailable_sign.png";
import { AppConfig } from "../../context/context";
import { BRAND_NAMES } from "../../utils/constants";
import { Typography } from "@mui/material";

const PageNotFound = () => {
  const { i18n, t } = useTranslation();
  const { config } = useContext(AppConfig);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "var(--kyocera-background-grey)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {config?.configBrand === BRAND_NAMES.KYOCERA && (
        <img
          style={{ maxHeight: 40, marginBottom: 20 }}
          alt="Kyocera"
          src={KyoceraLogo}
        />
      )}
      <img
        style={{ maxHeight: 40, marginBottom: 20 }}
        alt="dev-portal"
        src={DevPortalLogo}
      />
      <Typography variant="h4" sx={{ color: "red", marginTop: 5 }}>
        <strong>404</strong>
      </Typography>
      <Typography variant="h5" sx={{ marginBottom: 5 }}>
        <strong>{t("page_not_found")}</strong>
      </Typography>
      <img
        alt="dev-portal"
        src={UnavailableLogo}
      />
      <Typography sx={{ marginTop: 5 }}>{t("page_not_exist")}</Typography>
    </div>
  );
};

export default PageNotFound;
